import React, { FunctionComponent } from 'react';
import styles from './Skeletons.module.scss';

const Skeletons: FunctionComponent = () => {
  return (
    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 mt-0 pb-5">
      <div className="col ">
        <div className={`${styles.skeleton} ${styles.skeletonCard} rounded-3 w-100`}></div>
      </div>
      <div className="col ">
        <div className={`${styles.skeleton} ${styles.skeletonCard} rounded-3 w-100`}></div>
      </div>
      <div className="col ">
        <div className={`${styles.skeleton} ${styles.skeletonCard} rounded-3 w-100`}></div>
      </div>
    </div>
  );
};
export default Skeletons;
